<template>
  <div>
    <ion-list lines="none">
      <ion-item v-for="(checkbox, index) in checkboxes" :key="index">
        <ion-checkbox
          slot="end"
          @update:modelValue="setModelValue($event, checkbox, index)"
          :modelValue="checkbox.isChecked"
          :disabled="checkbox.isDisabled"
        >
        </ion-checkbox>
        <ion-label class="ion-text-wrap ion-text-right">
          <!-- <ion-grid class="ion-no-padding">
            <ion-row class="ion-align-items-center">
              <ion-col> -->
          <ion-icon
            v-if="checkbox.icon"
            style="vertical-align: middle; margin-right: 5px"
            class="ion-margin-right"
            :src="require('@lib/assets/icons/' + checkbox.icon.src)"
            :size="checkbox.icon.size"
          ></ion-icon>
          <!-- </ion-col>
              <ion-col size="auto"> -->
          {{ checkbox.value }}
          <!-- </ion-col>
            </ion-row>
          </ion-grid> -->
        </ion-label>
      </ion-item>
      <ion-item v-if="question.showSonstiges">
        <ion-checkbox
          slot="end"
          v-model="hasSonstiges"
          :disabled="isSonstigesDisabled"
        ></ion-checkbox>
        <ion-label class="ion-text-wrap ion-text-right">Sonstiges</ion-label>
      </ion-item>
    </ion-list>
    <ion-input
      v-if="hasSonstiges"
      placeholder="Sonstiges ..."
      v-model="sonstiges"
    ></ion-input>
    <next-question-button
      @click="emitValues"
      :disabled="!hasValue && !hasSonstiges"
    />
  </div>
</template>

<script>
import {
  IonList,
  IonItem,
  IonCheckbox,
  IonLabel,
  IonInput,
  IonIcon,
  // IonGrid,
  // IonRow,
  // IonCol,
} from "@ionic/vue";
import NextQuestionButton from "./NextQuestionButton";

export default {
  emits: ["done"],
  components: {
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel,
    NextQuestionButton,
    IonInput,
    IonIcon,
    // IonGrid,
    // IonRow,
    // IonCol,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    zahn: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialCheckboxes: [],
      disabledCheckboxes: [],
      checkboxes: [],
      hasSonstiges: false,
      sonstiges: "",
      isSonstigesDisabled: false,
    };
  },
  watch: {
    zahn() {
      this.initCheckboxes();
    },
  },
  created() {
    this.initCheckboxes();
  },
  methods: {
    initCheckboxes() {
      const checkboxes = [];
      const disabledCheckboxes = [];
      for (const option of this.question.options) {
        if (!(option.hide === "zahn" && this.zahn)) {
          checkboxes.push({
            value: option.value,
            id: option.id,
            icon: option.icon,
            action: option.action,
            isChecked: false,
            isDisabled: false,
          });
          disabledCheckboxes.push({
            value: option.value,
            id: option.id,
            icon: option.icon,
            action: option.action,
            isChecked: false,
            isDisabled: true,
          });
        }
      }
      this.initialCheckboxes = JSON.parse(JSON.stringify(checkboxes));
      this.disabledCheckboxes = disabledCheckboxes;
      this.checkboxes = checkboxes;
    },
    setModelValue(event, checkbox, index) {
      if (
        [
          "Keine",
          "Weiß nicht genau",
          "Anders",
          "Gar nicht",
          "Weiß es nicht genau",
          "Nein",
          "Weiß nicht",
        ].includes(checkbox.value) &&
        event
      ) {
        const newCheckboxes = JSON.parse(
          JSON.stringify(this.disabledCheckboxes)
        );
        newCheckboxes[index].isChecked = true;
        newCheckboxes[index].isDisabled = false;
        this.checkboxes = newCheckboxes;
        this.hasSonstiges = false;
        this.isSonstigesDisabled = true;
      } else if (
        [
          "Keine",
          "Weiß nicht genau",
          "Anders",
          "Gar nicht",
          "Weiß es nicht genau",
          "Nein",
          "Weiß nicht",
        ].includes(checkbox.value) &&
        !event
      ) {
        this.checkboxes = JSON.parse(JSON.stringify(this.initialCheckboxes));
        this.isSonstigesDisabled = false;
      } else {
        checkbox.isChecked = event;
      }

      if (checkbox.action === "showOrthodonticsModal") {
        this.$store.commit("setShowOrthodonticsModal", true);
        this.$nextTick(() => {
          checkbox.isChecked = false;
        });
      }
    },
    emitValues() {
      const values = [];
      const valueIds = [];
      for (const checkbox of this.checkboxes) {
        // console.log(checkbox);
        if (checkbox.isChecked) {
          values.push(checkbox.value);
          if (checkbox.id) {
            valueIds.push(checkbox.id);
          }
        }
      }
      const joinedValues = values.join(", ");
      const emitValue = {
        value:
          joinedValues +
          (this.hasSonstiges && joinedValues ? ", " : "") +
          (this.hasSonstiges ? "Sonstiges: " + this.sonstiges : ""),
        id: this.question.id,
      };
      if (valueIds.length > 0) {
        emitValue.valueIds = valueIds;
      }
      this.$emit("done", emitValue);
    },
  },
  computed: {
    hasValue() {
      let result = false;
      for (const checkbox of this.checkboxes) {
        if (checkbox.isChecked) {
          result = true;
          break;
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
ion-checkbox {
  margin-left: 20px;
}
ion-item {
  --color: var(--ion-color-primary);
}
</style>
